import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-gray-800 text-white py-12 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between mb-8">
          <div className="mb-8 md:mb-0">
            <div className="font-semibold text-xl text-indigo-400 mb-4">
              jackcarlsoncopy
            </div>
            <p className="text-gray-400 max-w-xs">
              Personalized marketing solutions that drive real business growth.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-medium text-lg mb-4">Services</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#services" className="text-gray-400 hover:text-white transition-colors">
                    Copy Optimization
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-white transition-colors">
                    Lead Generation
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-white transition-colors">
                    Paid Advertising
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-white transition-colors">
                    Organic Growth
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium text-lg mb-4">Company</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#about" className="text-gray-400 hover:text-white transition-colors">
                    About
                  </a>
                </li>
                <li>
                  <a href="#packages" className="text-gray-400 hover:text-white transition-colors">
                    Packages
                  </a>
                </li>
                <li>
                  <a href="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-span-2 md:col-span-1">
              <h3 className="font-medium text-lg mb-4">Connect</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#contact" className="text-gray-400 hover:text-white transition-colors">
                    Contact
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/john-carlson-iii" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                    LinkedIn
                  </a>
                </li>
                <li>
                  <a href="mailto:wcs@jackcarlsoncopy.com" className="text-gray-400 hover:text-white transition-colors">
                    wcs@jackcarlsoncopy.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-700 text-center md:text-left text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} jackcarlsoncopy. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};